import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { ROUTES } from '@/lib/routes';
import { SetupPage } from '@/pages/setup/SetupPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, roleId } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // In dev mode, bypass auth for local development
    if (import.meta.env.DEV && import.meta.env.VITE_COGNITO_USER_POOL_ID === undefined) {
      return <>{children}</>;
    }
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // User is authenticated but not set up in the system - show setup page
  if (!roleId) {
    return <SetupPage />;
  }

  return <>{children}</>;
}
